import React, { useState } from "react";
import "./DashboardSideBar.css";
import { Link } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { MdDeliveryDining } from "react-icons/md";
export default function DashboardSideBar() {
  const [activeLink, setActiveLink] = useState("orders");
  function handleActiveLink(link) {
    setActiveLink(link);
  }
  return (
    <aside className="dashboardSideBar">
      <div className="dash-logo-section">
        <img src="/UC-BG.png" alt="logo" />
      </div>
     
      <ul className="dash-links">
        <li
          onClick={() => handleActiveLink("orders")}
          role="link"
          className={activeLink === "orders" && "active"}
        >
          <Link to="orders">
            <MdDeliveryDining /> Orders
          </Link>
        </li>
        <li
          onClick={() => handleActiveLink("profile")}
          role="link"
          className={activeLink === "profile" && "active"}
        >
          <Link to="profile">
            <CgProfile /> User Profile
          </Link>
        </li>
        <li
          onClick={() => handleActiveLink("settings")}
          role="link"
          className={activeLink === "settings" && "active"}
        >
          <Link to="settings">
            <IoSettingsOutline /> Settings
          </Link>
        </li>
      </ul>
    </aside>
  );
}
